import { useQuery } from '@tanstack/react-query'
import { parseQueryParams } from '../../../utilities/parsers'
import apiUrl from '../../../apis/api.url'
import { getData } from '../../../apis/api.helpers'
import { useAuthStore } from '../../../store/authStore'

const buildUrlWithParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}

const fetchBanner = async () => {
  const url = buildUrlWithParams(apiUrl.BANNER_LIST)
  const response = await getData(url)
  return response
}
const fetchBannerUser = async () => {
  const url = buildUrlWithParams(apiUrl.BANNER_LIST_USER)
  const response = await getData(url)
  return response
}

export const useBannerList = () => {
  const authenticated = useAuthStore((state) => state.authenticated)
  return useQuery(
    ['members_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchBannerUser()
      } else {
        return fetchBanner()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchTestimonial = async () => {
  const url = buildUrlWithParams(apiUrl.TESTIMONIALS)
  const response = await getData(url)
  return response
}
const fetchTestimonialUser = async () => {
  const url = buildUrlWithParams(apiUrl.TESTIMONIALS)
  const response = await getData(url)
  return response
}

export const useTestimonialList = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['testimonials_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchTestimonialUser()
      } else {
        return fetchTestimonial()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchAdvertisement = async () => {
  const url = buildUrlWithParams(apiUrl.ADVERTISEMENT_LIST)
  const response = await getData(url)
  return response
}

export const useFetchAdvertisement = () => {
  return useQuery(['worker_jobtype_listing'], () => fetchAdvertisement(), {
    refetchOnWindowFocus: false,
  })
}
const fetchYoutubeVideos = async () => {
  const url = buildUrlWithParams(apiUrl.VIDEOS)
  const response = await getData(url)
  return response
}

export const useYoutubeVideos = () => {
  return useQuery(['videos_listing'], () => fetchYoutubeVideos(), {
    refetchOnWindowFocus: false,
  })
}

const tranningCalenderDetails = async (id: any) => {
  const response = await getData(`${apiUrl.PROGRAM_DETAILS}/${id}`)
  return response.data
}

export const useTranningCalenderDetails = (id: any) => {
  return useQuery(
    ['tranning-calender-details', id],
    () => tranningCalenderDetails(id),
    {
      enabled: !!id, // prevents query from running if id is undefined or null
    }
  )
}
const fetchPartners = async () => {
  const url = buildUrlWithParams(apiUrl.PARTNER_LIST)
  const response = await getData(url)
  return response
}

export const usePartners = () => {
  return useQuery(['partners_listing'], () => fetchPartners(), {
    refetchOnWindowFocus: false,
  })
}
const fetchPhotos = async () => {
  const url = buildUrlWithParams(apiUrl.PHOTO_LIST)
  const response = await getData(url)
  return response
}

export const usePhotos = () => {
  return useQuery(['photo_listing'], () => fetchPhotos(), {
    refetchOnWindowFocus: false,
  })
}
